import React, { FC, useState } from 'react'
import { ModalSheet } from '@/atoms/ModalSheet'
import { TheaterPreferencesProvider } from '../TheaterPreferences/TheaterPreferencesContext'
import { ExistingPreferencesStep } from '../TheaterPreferences/steps/ExistingPreferencesStep'
import { TheaterSelectionStep } from '../TheaterPreferences/steps/TheaterSelectionStep'
import { AutobookConfirmationStep } from './steps/AutobookConfirmationStep'
import { InfoAndPhoneStep } from './steps/InfoAndPhoneStep'
import { AutoBookStep, AutoBookModalProps } from './types'

// Inner component that uses the context
const AutoBookContent: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState<AutoBookStep>(AutoBookStep.INFO_AND_PHONE)

  const renderCurrentStep = () => {
    switch (currentStep) {
      case AutoBookStep.INFO_AND_PHONE:
        return <InfoAndPhoneStep setCurrentStep={setCurrentStep} onClose={onClose} />
      case AutoBookStep.THEATER_SELECTION:
        return (
          <TheaterSelectionStep
            effectiveCountryCode="US"
            onNextStep={() => setCurrentStep(AutoBookStep.VIEW_EXISTING_PREFERENCES)}
            onClose={onClose}
          />
        )
      case AutoBookStep.VIEW_EXISTING_PREFERENCES:
        return (
          <ExistingPreferencesStep
            onClose={onClose}
            onEditTheater={() => setCurrentStep(AutoBookStep.THEATER_SELECTION)}
            onSave={() => setCurrentStep(AutoBookStep.CONFIRMATION)}
            isAutobookFlow
          />
        )
      case AutoBookStep.CONFIRMATION:
        return <AutobookConfirmationStep onClose={onClose} />
      default:
        return null
    }
  }

  return <div className="h-full">{renderCurrentStep()}</div>
}

// TODO: Disable save on infoand phonestep if no phone number is set
// Main modal component that provides the context
export const AutoBookModal: FC<AutoBookModalProps> = ({ open, onClose }) => {
  return (
    <ModalSheet
      isOpen={open}
      onClose={onClose}
      panelClasses="w-full max-w-xl h-[725px] overflow-hidden"
      backgroundScreenColor="black"
    >
      <TheaterPreferencesProvider>
        <div className="flex h-full flex-col">
          <AutoBookContent onClose={onClose} />
        </div>
      </TheaterPreferencesProvider>
    </ModalSheet>
  )
}
